<template>
  <v-dialog v-model="dialog" persistent width="400">
    <v-card>
      <v-card-title class="d-flex">
        Verify OTP
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pt-2">
        <v-form ref="form" v-model="isValid">
          <v-text-field label="OTP" v-model="otp" :rules="rules" outlined dense>
          </v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { FIELD } from "../../assets/js/rules";
import userService from "../../assets/services/user.service";
export default {
  props: {
    type: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      dialog: false,
      form: {},
      isValid: false,
      otp: "",
      AuthKey: "",
      rules: FIELD,
    };
  },
  methods: {
    init(data, AuthKey) {
      const vm = this;
      vm.dialog = true;
      vm.form = data;
      vm.AuthKey = AuthKey;
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let { phone, password } = vm.form;
      let params = {
        MobileNo: phone,
        OTP: vm.otp,
        Password: password,
        AuthKey: vm.AuthKey,
        Source: "JSON",
      };
      try {
        vm.$loader.show();
        let res = {};
        res = await userService.verifyRegisterOTP(params);
        let { status, message } = res.data;
        vm.$loader.hide();
        if (status == "true") {
          vm.$emit("success");
          vm.dialog = false;
        }
        vm.$alert.show(message);
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style>
</style>